import ZapOff from "./ZapOff";

export * from "./Airplay";
export * from "./Battery";
export * from "./BatteryCharging";
export * from "./BatteryFull";
export * from "./BatteryLow";
export * from "./BatteryMedium";
export * from "./BattreyWarning";
export * from "./Bluetooth";
export * from "./BluetoothConnected";
export * from "./BluetoothOff";
export * from "./BluetoothSearching";
export * from "./Cable";
export * from "./Cast";
export * from "./CirclePower";
export * from "./ColudOff";
export * from "./Headphones";
export * from "./Headset";
export * from "./Monitor";
export * from "./MonitorCheck";
export * from "./MonitorCog";
export * from "./MonitorDot";
export * from "./MonitorDown";
export * from "./MonitorOff";
export * from "./MonitorPause";
export * from "./MonitorPlay";
export * from "./MonitorSmartphone";
export * from "./MonitorSpeaker";
export * from "./MonitorStop";
export * from "./MonitorUp";
export * from "./MonitorX";
export * from "./NootbookTabs";
export * from "./Power";
export * from "./PowerOff";
export * from "./Router";
export * from "./Satellite";
export * from "./SatelliteDish";
export * from "./Signal";
export * from "./SignalHigh";
export * from "./SignalLow";
export * from "./SignalMedium";
export * from "./SignalZero";
export * from "./Smartphone";
export * from "./SmartphoneCharging";
export * from "./SquarePower";
export * from "./Voicemail";
export * from "./Wifi";
export * from "./WifiHigh";
export * from "./WifiLow";
export * from "./WifiOff";
export * from "./WifiZero";
export * from "./Zap";
export * from "./ZapOff";

export const Conn = {
  ZapOff,
};
